import { HttpClient } from '@angular/common/http';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

export const addressValidator = (http: HttpClient) => {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    // Timer 500 used for debounce value changes and making api request only when value is stable
    return timer(500).pipe(
      switchMap(() => {
        // Check if every fields has some values to make a API call
        const { addressOne, addressTwo, city, state, zip } = control.value;
        const isAddressFull =
          (addressOne?.length > 0 || addressTwo?.length > 0) && city?.length > 0 && state?.length > 0 && zip?.length > 0;
        if (isAddressFull) {
          // Prepare data
          // eslint-disable-next-line max-len
          const url = `http://production.shippingapis.com/ShippingAPI.dll?API=Verify&XML=<AddressValidateRequest USERID="418EMDS02293"><Revision>1</Revision><Address ID="0"><Address1>${addressTwo}</Address1><Address2>${addressOne}</Address2><City>${city}</City><State>${state}</State><Zip5>${zip}</Zip5><Zip4 /></Address></AddressValidateRequest>`;
          return http.get(url, { responseType: 'text' }).pipe(
            map((response) => {
              // Parse XML response and find valid data for fields
              const parser = new DOMParser().parseFromString(response, 'text/xml');
              const isError = parser.getElementsByTagName('Error').length > 0;
              if (isError) {
                return null;
              }
              const validAddressOne = parser.getElementsByTagName('Address2')?.[0]?.textContent;
              const validAddressTwo = parser.getElementsByTagName('Address1')?.[0]?.textContent ?? '';
              const validCity = parser.getElementsByTagName('City')?.[0]?.textContent;
              const validState = parser.getElementsByTagName('State')?.[0]?.textContent;
              const validZip = parser.getElementsByTagName('Zip5')?.[0]?.textContent;
              const validDataFromResponse = (
                typeof validAddressOne === 'string' &&
                typeof validAddressTwo === 'string' &&
                typeof validCity === 'string' &&
                typeof validState === 'string' &&
                typeof validZip === 'string'
              );

              const addressesIsDifferent = (
                addressOne !== validAddressOne ||
                addressTwo !== validAddressTwo ||
                city !== validCity ||
                state !== validState ||
                zip !== validZip
              );

              // If values from response is not the same as in fields, return error object
              if (validDataFromResponse && addressesIsDifferent) {
                return {
                  address: {
                    currentAddress: {
                      addressOne,
                      addressTwo,
                      city,
                      state,
                      zip,
                    },
                    correctAddress: {
                      addressOne: validAddressOne,
                      addressTwo: validAddressTwo,
                      city: validCity,
                      state: validState,
                      zip: validZip,
                    },
                  },
                };
              }
              return null;
            }),
            catchError(() => of(null))
          );
        }
        return of(null);
      })
    );
  };
};
